var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"search-page"}},[_c('FilterableProductsLayout',{attrs:{"filter":{},"title":_vm.$t('Search'),"breadcrumbs":[{
      text: _vm.$t('Home'),
      link: _vm.localePath('/')
    }, { text: _vm.$t('Search'), link: _vm.localePath('/search')}]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }